import { Button, Col, Form, notification, Row, Select } from 'antd'
import AppContext from 'context/AppContext'
import React, { useContext, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import {
  useDerslerQuery,
  useOkulOgretmenleriQuery,
  useOkulSiniflariQuery,
  useSinifDersiDetayQuery,
  useSinifDersiEkleMutation,
} from '../../../../../gql/GeneratedGraphqlTypes'
import Spinner from '../../../../spinner/Spinner'

const ClassLessonsDetailPage = () => {
  const { id } = useParams()
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const { okul } = useContext(AppContext)
  const [sinifDersleriEkle] = useSinifDersiEkleMutation()

  const {
    data: sinifDersiData,
    loading: sinifDersiLoading,
    error: sinifDersiError,
  } = useSinifDersiDetayQuery({
    variables: {
      id: parseInt(id ? id : '0'),
    },
    skip: !id, // ID yoksa sorguyu çalıştırma
    fetchPolicy: 'network-only',
  })
  const {
    data: ogretmenData,
    loading: ogretmenLoading,
    error: ogretmenError,
  } = useOkulOgretmenleriQuery({
    variables: {
      sube_id: okul?.id ?? 0,
    },

    fetchPolicy: 'network-only',
  })
  const {
    data: dersData,
    loading: dersLoading,
    error: dersError,
  } = useDerslerQuery({
    fetchPolicy: 'network-only',
  })
  const {
    data: sinifData,
    loading: sinifLoading,
    error: sinifError,
  } = useOkulSiniflariQuery({
    variables: {
      sube_id: okul?.id ?? 0,
    },
    fetchPolicy: 'network-only',
  })
  useEffect(() => {
    if (sinifDersiData) {
      form.setFieldsValue({
        sinif: sinifDersiData.sinifDersiDetay?.sinif,
        ders: sinifDersiData.sinifDersiDetay?.ders,
        ogretmen: sinifDersiData.sinifDersiDetay?.ogretmen,
      })
    }
  }, [sinifDersiData, form])

  if (sinifDersiLoading || ogretmenLoading || dersLoading || sinifLoading) {
    return <Spinner color="red" showSpinner={sinifDersiLoading} />
  }

  if (sinifDersiError || ogretmenError || dersError || sinifError) {
    notification.success({
      message: '',
      description: `Bir hata meydana geldi`,
      duration: 6,
    })
  }
  const handleSubmit = async () => {
    const values = await form.validateFields()
    const input = {
      sinif_id: values.sinif,
      ders_id: values.ders,
      ogretmen_id: values.ogretmen,
      id: parseInt(id ? id : '0'),
    }

    try {
      const response = await sinifDersleriEkle({
        variables: {
          input: {
            sinif_id: input.sinif_id,
            ders_id: input.ders_id,
            ogretmen_id: input.ogretmen_id,
            id: input.id,
          },
        },
      })

      if (response.data?.sinifDersiEkle.success) {
        notification.success({
          message: '',
          description: response.data?.sinifDersiEkle?.message,
          duration: 6,
        })
        navigate(-1)
      } else {
        notification.error({
          message: '',
          description: response.data?.sinifDersiEkle?.message || 'Bir hata oluştu',
        })
      }
    } catch {
      notification.error({
        message: '',
        description: 'Listeyi gönderirken bir hata oluştu.',
        duration: 6,
      })
    }
  }
  return (
    <div>
      <div className="okul-subeler-detail-page">
        {id ? (
          <>
            <h1>Sınıf Dersleri Detay </h1>
            <Form onFinish={handleSubmit} className="okul-yonetim-detail-form" layout="vertical" form={form}>
              <Row className="user-info-row" gutter={16}>
                <Col span={24} className="user-info-col">
                  <Col span={8}>
                    <Form.Item label="Sınıf" name="sinif" rules={[{ required: true, message: 'Lütfen sınıf girin!' }]}>
                      <Select
                        style={{ width: '100%' }}
                        suffixIcon={<></>}
                        placeholder="Ders seçiniz"
                        options={sinifData?.okulSiniflari?.siniflar?.map((sinif) => ({
                          label: sinif?.isim,
                          value: sinif?.id,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Ders" name="ders" rules={[{ required: true, message: 'Lütfen ders girin!' }]}>
                      <Select
                        style={{ width: '100%' }}
                        suffixIcon={<></>}
                        placeholder="Ders seçiniz"
                        options={dersData?.dersler?.map((ders) => ({
                          label: ders?.isim,
                          value: ders?.id,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label="Öğretmen"
                      name="ogretmen"
                      rules={[{ required: true, message: 'Lütfen öğretmen girin!' }]}
                    >
                      <Select
                        style={{ width: '100%' }}
                        suffixIcon={<></>}
                        placeholder="Öğretmen seçiniz"
                        options={ogretmenData?.okulOgretmenleri?.ogretmenler?.map((ogretmen) => ({
                          label: ogretmen?.ogretmen,
                          value: ogretmen?.id,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                </Col>
              </Row>
              <Button className="back-btn" onClick={() => navigate(-1)}>
                Geri
              </Button>
              <Button className="update-btn" htmlType="submit">
                Güncelle
              </Button>
            </Form>
          </>
        ) : (
          <>
            <h1>Sınıf Dersleri Detay </h1>
            <Form onFinish={handleSubmit} className="okul-yonetim-detail-form" layout="vertical" form={form}>
              <Row className="user-info-row" gutter={16}>
                <Col span={24} className="user-info-col">
                  <Col span={8}>
                    <Form.Item label="Sınıf" name="sinif" rules={[{ required: true, message: 'Lütfen sınıf girin!' }]}>
                      <Select
                        style={{ width: '100%' }}
                        suffixIcon={<></>}
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                        }
                        placeholder="Sınıf seçiniz"
                        options={sinifData?.okulSiniflari?.siniflar?.map((sinif) => ({
                          label: sinif?.isim,
                          value: sinif?.id,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Ders" name="ders" rules={[{ required: true, message: 'Lütfen ders girin!' }]}>
                      <Select
                          style={{ width: '100%' }}
                          showSearch
                          placeholder="Ders seçiniz"
                        
                          filterOption={(input, option) =>
                              (option?.label as string).toLowerCase().includes(input.toLowerCase())
                          }
                          options={dersData?.dersler?.map((ders) => ({
                            label: ders?.isim,
                            value: ders?.id,
                          }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label="Öğretmen"
                      name="ogretmen"
                      rules={[{ required: true, message: 'Lütfen öğretmen girin!' }]}
                    >
                      <Select
                        style={{ width: '100%' }}
                        suffixIcon={<></>}
                        placeholder="Öğretmen seçiniz"
                        options={ogretmenData?.okulOgretmenleri?.ogretmenler?.map((ogretmen) => ({
                          label: ogretmen?.ogretmen,
                          value: ogretmen?.id,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                </Col>
              </Row>
              <Button className="back-btn" onClick={() => navigate(-1)}>
                Geri
              </Button>
              <Button className="update-btn" htmlType="submit">
                Kaydet
              </Button>
            </Form>
          </>
        )}
      </div>
    </div>
  )
}

export default ClassLessonsDetailPage
